import ComponentBase from "./componentBase";

export default abstract class BtnHomeOpBase extends ComponentBase{
    

    constructor(
        protected idBtn:string,
        protected container:HTMLElement,
        protected elementToRender:string
    ){
        super(container,idBtn,elementToRender);
    }

    public abstract clickAction();

    public actionClick(){
        this.elementRendered.click();
        this.elementRendered.classList.add("d-none");
    }
}